import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import LoadingButton from "@mui/lab/LoadingButton";
// import Grid from '@mui/material/Grid'
import { useAuth } from "../contexts/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import paths from "../constants/paths";

import BreadCrumb from "../components/BreadCrumb";
import { ReactComponent as ShieldExclamation } from "../assets/Icons/shield-exclamation.svg";
import { useBasicInfo } from "../contexts/BasicInfo";
import { LOADING, treatment_program } from "../constants/common";
import SetGeoLocations from "../hooks/setGeoLocations";
import { useGeneralProfile } from "../contexts/Organization";
import InviteTherapistModal from "../components/InviteTherapistModal";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import getNavMenu from "../constants/navMenu";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import { useNotifcations } from "../contexts/Notifications";
import useResize from "../hooks/useResize";

import { identifyUser, trackClickEvent } from "../mixpanel";
import Footer from "../components/Footer";
import DeviceMetadataTracker from "../components/DeviceMetadataTracker";
import { useAlert } from "../contexts/Alert";

const MainLayout = ({
  children,
  currentPage,
  currentPageTitle,
  buttonProps,
  noGap,
  noWarning,
  noFooter = false,
  noFeedback = false,
}) => {
  const {
    isLoggedIn,
    resendEmailVerification,
    resendEmailStatus,
    account_type,
    permissions,
  } = useAuth();
  const { unSeenNotifications } = useNotifcations();
  const [openAlert, setOpenAlert] = useState(false);
  const { sendAlert } = useAlert();
  const [invitationModalVisible, setInvitationModalVisible] = useState(false);
  const navigate = useNavigate();
  const { data } = useBasicInfo();
  const { facilityInfo } = useGeneralProfile();
  const info = account_type === treatment_program ? facilityInfo : data;

  const [selectedTab, setSelectedTab] = React.useState("");
  const location = useLocation();
  const isMobileView = useResize(600);

  const toggleInvitationModalVisability = () => {
    setInvitationModalVisible((c) => !c);
    trackClickEvent("Viewed User Menu Item - Invite", {
      page: "Homepage",
      component: "User Menu",
      button: "invite therapist",
    });
  };

  function handleOpenAlert() {
    setOpenAlert(true);
  }

  // function handleCloseAlert() {
  //   setOpenAlert(false);
  // }

  function resendEmail() {
    resendEmailVerification({ email: info?.email });
  }

  const navMenu = getNavMenu(permissions, info);

  useEffect(() => {
    const tab = navMenu.findIndex(
      (item) => item.path === window.location.pathname,
    );
    setSelectedTab(tab);
  }, [window.location.pathname]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isValidated = params.get('isValidated');

    if (Boolean(isValidated) === true) {
      const message = "Your email has been verified.\nPlease log in to begin exploring the network.";
      sendAlert(message, "success")

      params.delete('isValidate');
      const newSearch = params.toString();
      const newUrl = {
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : '',
      };

      navigate(newUrl, { replace: true });
    }
  }, [location.search, navigate, location.pathname]);

  useEffect(() => {
    if (!isLoggedIn) {
      // Check if we are in the middle of a logout
      const isLoggingOut = sessionStorage.getItem("isLoggingOut");
      if (isLoggingOut) {
        // Remove the flag and skip setting redirectPath
        sessionStorage.removeItem("isLoggingOut");
      } else {
        const alreadySet = sessionStorage.getItem("redirectPath");
        if (!alreadySet) {
          const currentPath = window.location.pathname + window.location.search;
          sessionStorage.setItem("redirectPath", currentPath);
        }
      }
      navigate(paths.login);
    } else {
      identifyUser(info);
    }
  }, [isLoggedIn]);

  // Route protection for disabled pages
  useEffect(() => {
    if (
      permissions &&
      (location.pathname.includes("/referrals") ||
        location.pathname.includes("/notifications")) &&
      permissions?.notification_update === false
    ) {
      navigate(paths.home);
    }
  }, [permissions, location.pathname]);

  useEffect(() => {
    if (
      Object.keys(info)?.length > 0 &&
      !Boolean(info?.email_verified_at) &&
      !window.location.pathname.startsWith("/public/")
    ) {
      handleOpenAlert();
    }
  }, [info]);

  if (JSON.parse(process.env.REACT_APP_TRIGGER_GEO_LOCATION || "false")) {
    if (!JSON.parse(localStorage.getItem("locations_set"))) SetGeoLocations();
  }

  if (!isLoggedIn) return null;

  return (
    <>
      <DeviceMetadataTracker />
      <Header
        toggleInvitationModalVisability={toggleInvitationModalVisability}
      />
      {Boolean(currentPage) &&
        !(
          isMobileView &&
          (currentPage === "Messages" || currentPage === "Discussion Groups")
        ) && (
          <BreadCrumb
            currentPage={currentPage}
            buttonProps={buttonProps}
            currentPageTitle={currentPageTitle}
          />
        )}
      <Box
        component="main"
        pt={noGap ? 0 : 3}
        pb={3}
        backgroundColor="background.default"
        minHeight={`calc(100% - 122px)`}
      >
        <Container>
          {/* <Grid container justifyContent='center' spacing={{ xs: 0, md: 3 }}> */}
          {/* <Grid xs={12} md={7} item> */}
          {openAlert && !noGap && !noWarning && (
            <Alert
              severity="error"
              sx={{
                backgroundColor: "#FAF4D4",
                borderRadius: 1,
                border: "1px solid #EECD63",
                mb: 1.5,
                mt: -1.5,
                py: 0.5,
                px: 3,
                alignItems: "center",
              }}
              icon={<ShieldExclamation />}
            >
              Please check your inbox under {info?.email} to confirm your email.
              Can't find verification email?{" "}
              <LoadingButton
                size="small"
                sx={{
                  p: 0,
                  minWidth: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={resendEmail}
                loading={resendEmailStatus === LOADING}
                disabled={!permissions?.notification_update}
              >
                Resend
              </LoadingButton>
            </Alert>
          )}
          {/* </Grid> */}
          {/* </Grid> */}
        </Container>
        {children}
      </Box>

      {!noFooter && <Footer />}

      {invitationModalVisible ? (
        <InviteTherapistModal
          open={invitationModalVisible}
          onClose={toggleInvitationModalVisability}
        />
      ) : null}
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
        elevation={3}
      >
        {isMobileView ? (
          <BottomNavigation
            showLabels
            value={selectedTab}
            sx={{
              "& .MuiBottomNavigationAction-root": {
                minWidth: "auto",
                padding: "6px 4px",
                fontSize: "10px",
              },
              "& .MuiBottomNavigationAction-label": {
                fontSize: "10px",
                marginTop: "2px",
              },
            }}
          >
            {navMenu.map((item, index) => {
              return (
                <BottomNavigationAction
                  onClick={() => navigate(item.path)}
                  key={index}
                  label={item.text}
                  icon={
                    item.text === "Notifications" ? (
                      <Badge
                        badgeContent={unSeenNotifications}
                        color="error"
                        size="large"
                      >
                        {selectedTab !== index ? (
                          <item.Icon />
                        ) : (
                          <item.DarkIcon />
                        )}
                      </Badge>
                    ) : selectedTab !== index ? (
                      <item.Icon />
                    ) : (
                      <item.DarkIcon />
                    )
                  }
                />
              );
            })}
          </BottomNavigation>
        ) : null}
      </Paper>
    </>
  );
};

export default MainLayout;
